import * as yup from 'yup';

export const groupsAdminSchema = yup.object().shape({
  name: yup.string().optional(),
  storeGroupId: yup.string().optional(),
});
